import Vue from 'vue';
import Vuetify from 'vuetify';
import pt from 'vuetify/es5/locale/pt';

Vue.use(Vuetify, {
  theme: {
    primary: '#1d9a5a',
    red: '#FF4B4B',
    secondary: '#00d552',
    greenLight: '#32ba72',
    accent: '#3060CA',
    gray: "#50514F",
    grayLight: "#fafafa",
    ticket: "#fffcdd",
    verdeFinanceiro: "#1D9A5A",
    "lb-primary": '#3060CA',
    "lb-danger": '#D50000',
    "lb-success": '#2BB713',
    "lb-primary": '#1d9a5a',
    "lb-warning": '#f0ad4e',
    "lb-info": '#056CA0'
  },
  lang: {
    locales: { pt },
    current: 'pt'
  },
  options: {
    themeVariations: ['primary', 'secondary', 'accent'],
    extra: {
      mainToolbar: {
        color: 'primary',
      },
      sideToolbar: {
      },
      sideNav: 'primary',
      mainNav: 'primary lighten-1',
      bodyBg: '',
    }
  }
});

export default Vue;
